import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../App";
import { getTranslation } from "../i18n/translations";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = ({ setUser, lang = 'tr' }) => {
  const t = (key) => getTranslation(lang, key);
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [pendingUser, setPendingUser] = useState(null);
  const [pendingToken, setPendingToken] = useState(null);
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash.substring(1);
      const params = new URLSearchParams(hash);
      const sessionId = params.get("session_id");

      if (!sessionId) {
        setError(t('authSessionNotFound'));
        setTimeout(() => navigate("/"), 2000);
        return;
      }

      try {
        const response = await api.get("/auth/session", {
          headers: { "X-Session-ID": sessionId }
        });
        window.history.replaceState({}, document.title, "/auth/callback");
        // Oturumu hemen aktifleştirme — önce kullanıcıdan onay al (ortak bilgisayar güvenliği)
        setPendingUser(response.data.user);
        setPendingToken(response.data.session_token);
      } catch (err) {
        console.error("Auth error:", err);
        setError(t('authFailed'));
        setTimeout(() => navigate("/"), 2000);
      }
    };

    processAuth();
  }, [navigate]);

  const handleContinue = () => {
    const domain = window.location.hostname;
    document.cookie = `session_token=${pendingToken}; path=/; domain=${domain}; secure; samesite=none; max-age=${7 * 24 * 60 * 60}`;
    localStorage.setItem("session_token", pendingToken);
    setUser(pendingUser);
    navigate("/dashboard");
  };

  const handleNotMe = async () => {
    // Bu cihazdaki Google oturumunu da kapat — bir sonraki girişte hesap sorulur
    window.open("https://accounts.google.com/Logout", "_blank");
    try {
      await api.post("/auth/logout", {}, {
        headers: { Authorization: `Bearer ${pendingToken}` }
      });
    } catch (_) {}
    localStorage.removeItem("session_token");
    document.cookie = `session_token=; path=/; domain=${window.location.hostname}; secure; samesite=none; max-age=0`;
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 p-4">
      <div className="text-center w-full max-w-md">
        {error ? (
          <>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <p className="text-red-600 text-lg">{error}</p>
          </>
        ) : pendingUser ? (
          <div className="bg-white rounded-2xl shadow-xl border border-slate-200 p-8" data-testid="auth-confirm-card">
            {pendingUser.picture ? (
              <img
                src={pendingUser.picture}
                alt={pendingUser.name}
                className="w-20 h-20 rounded-full mx-auto mb-4 border-4 border-amber-200"
              />
            ) : (
              <div className="w-20 h-20 rounded-full bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center text-white text-2xl font-bold mx-auto mb-4">
                {pendingUser.name?.charAt(0) || "U"}
              </div>
            )}
            <p className="font-bold text-xl text-slate-900">{pendingUser.name}</p>
            <p className="text-slate-500 mb-6" data-testid="auth-confirm-email">{pendingUser.email}</p>
            <p className="text-sm text-slate-600 mb-5">{t('authContinueQuestion')}</p>
            <div className="space-y-3">
              <button
                onClick={handleContinue}
                data-testid="auth-confirm-continue"
                className="w-full py-3 rounded-xl bg-amber-600 hover:bg-amber-700 text-white font-semibold transition-colors"
              >
                {t('authContinueYes')}
              </button>
              <button
                onClick={handleNotMe}
                data-testid="auth-confirm-notme"
                className="w-full py-3 rounded-xl border border-red-200 text-red-600 hover:bg-red-50 font-medium transition-colors"
              >
                {t('authNotMe')}
              </button>
              <p className="text-xs text-slate-400">
                {t('authNotMeNote')}
              </p>
            </div>
          </div>
        ) : (
          <>
            <div className="w-16 h-16 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-slate-600 text-lg">{t('authenticating')}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
